import { supabase } from './supabase';

class FotoPerfilService {
  private readonly BUCKET_NAME = 'fotos-perfil';

  // Upload de foto de perfil
  async uploadFotoPerfil(file: File, userId: string): Promise<{ url?: string; error?: string }> {
    try {
      // Validar arquivo
      if (!file) {
        return { error: 'Nenhum arquivo selecionado' };
      }

      // Validar tamanho (máximo 5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        return { error: 'A foto deve ter no máximo 5MB' };
      }

      // Validar tipo
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      if (!allowedTypes.includes(file.type)) {
        return { error: 'Apenas arquivos JPEG, PNG, GIF e WebP são permitidos' };
      }

      // Gerar nome único
      const fileExt = file.name.split('.').pop();
      const fileName = `${userId}_${Date.now()}.${fileExt}`;

      // Upload para o Supabase Storage
      const { data: uploadData, error: uploadError } = await supabase.storage
        .from(this.BUCKET_NAME)
        .upload(fileName, file, {
          cacheControl: '3600',
          upsert: true
        });

      if (uploadError) {
        console.error('Erro ao fazer upload:', uploadError);
        console.error('Detalhes do erro:', JSON.stringify(uploadError, null, 2));
        return { error: `Erro ao fazer upload da foto: ${uploadError.message}` };
      }

      // Obter URL pública
      const { data: publicUrlData } = supabase.storage
        .from(this.BUCKET_NAME)
        .getPublicUrl(fileName);

      return { url: publicUrlData.publicUrl };
    } catch (error) {
      console.error('Erro no upload de foto:', error);
      console.error('Detalhes do erro (catch):', JSON.stringify(error, null, 2));
      return { error: `Erro ao fazer upload da foto: ${error}` };
    }
  }

  // Deletar foto de perfil
  async deletarFotoPerfil(fileName: string): Promise<{ error?: string }> {
    try {
      const { error } = await supabase.storage
        .from(this.BUCKET_NAME)
        .remove([fileName]);

      if (error) {
        console.error('Erro ao deletar foto:', error);
        return { error: 'Erro ao deletar foto' };
      }

      return {};
    } catch (error) {
      console.error('Erro ao deletar foto:', error);
      return { error: 'Erro ao deletar foto' };
    }
  }
}

export default new FotoPerfilService();
